/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { IconLinkListComponentDisplay } from "cms/components/components/icon-links-list/display";
import { IconLinkListComponentEditor } from "cms/components/components/icon-links-list/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const IconLinkListComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <IconLinkListComponentDisplay />,
        editComponent: <IconLinkListComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

IconLinkListComponent.displayName = "IconLinkListComponent";
export { IconLinkListComponent };
